import { FC } from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';

// react-router-v6之后不支持路由中params的正则匹配, 为了避免react-router错误的将字符串识别成customerId,这里使用一个Layout组件处理
// 错误示例:
//      如果不处理, 直接敲入/open/xxx链接, xxx会被识别成为customerId
//      原因: 不再支持/:xxx(\d+)的正则匹配, 那么react-router会将任意字符串xxx识别成customerId
const RouteLayout: FC = () => {
    const location = useLocation();
    const { customerId } = useParams<{ customerId?: string }>();

    // 如果检测到存在customerId, 且customerId不是数字, 则替换掉错误的customerId
    if (customerId && !/\d+/.test(customerId)) {
        return (
            <Navigate
                to={{ ...location, pathname: location.pathname.replace(`/${customerId}`, '') }}
                state={location.state}
            />
        );
    }

    return <Outlet />;
};

export default RouteLayout;
